import { EventInput } from '@fullcalendar/angular';
import * as dayjs from 'dayjs';

let eventGuid = 0;
export function createEventId() {
	return String(eventGuid++);
}

const category = [
	{
		name: '--Select--',
		value: '',
		option: 'selected',
	},
	{
		name: 'Danger',
		value: 'bg-danger',
		option: '',
	},
	{
		name: 'Success',
		value: 'bg-success',
		option: '',
	},
	{
		name: 'Primary',
		value: 'bg-primary',
		option: '',
	},
	{
		name: 'Info',
		value: 'bg-info',
		option: '',
	},
	{
		name: 'Dark',
		value: 'bg-dark',
		option: '',
	},
	{
		name: 'Warning',
		value: 'bg-warning',
		option: '',
	},
];
var date = new Date();
var d = date.getDate();
var m = date.getMonth();
var y = date.getFullYear();
const calendarEvents: any[] = [
    {
        "id": "13",
        "title": "Fakri Zubek",
        "start": "2025-01-17T15:00:00.000Z",
        "end": "2025-01-17T17:00:00.000Z",
        "allDay": false,
        "className": "bg-soft-danger"
    },
    {
        "id": "14",
        "title": "Ken Solomon",
        "start": "2025-01-15T21:00:00.000Z",
        "end": "2025-01-15T23:00:00.000Z",
        "allDay": false,
        "className": "bg-soft-danger"
    },
    {
        "id": "15",
        "title": "JOHN YAP",
        "start": "2025-01-23T16:00:00.000Z",
        "end": "2025-01-23T18:00:00.000Z",
        "allDay": false,
        "className": "bg-soft-danger"
    },
    {
        "id": "16",
        "title": "Hannah Tring",
        "start": "2025-01-24T15:00:00.000Z",
        "end": "2025-01-24T17:00:00.000Z",
        "allDay": false,
        "className": "bg-soft-danger"
    },
    {
        "id": "17",
        "title": "Ken Mccord",
        "start": "2025-01-07T16:00:00.000Z",
        "end": "2025-01-07T18:00:00.000Z",
        "allDay": false,
        "className": "bg-soft-danger"
    },
    {
        "id": "18",
        "title": "Dennis Short",
        "start": "2025-01-31T16:00:00.000Z",
        "end": "2025-01-31T18:00:00.000Z",
        "allDay": false,
        "className": "bg-soft-danger"
    },
    {
        "id": "19",
        "title": "BRIAN RICHARDSON",
        "start": "2025-01-21T16:00:00.000Z",
        "end": "2025-01-21T18:00:00.000Z",
        "allDay": false,
        "className": "bg-soft-danger"
    },
    {
        "id": "20",
        "title": "FRANK PECKHAM",
        "start": "2025-01-14T16:00:00.000Z",
        "end": "2025-01-14T18:00:00.000Z",
        "allDay": false,
        "className": "bg-soft-danger"
    },
    {
        "id": "21",
        "title": "Yahya Nasser",
        "start": "2025-01-23T21:00:00.000Z",
        "end": "2025-01-23T23:00:00.000Z",
        "allDay": false,
        "className": "bg-soft-danger"
    },
    {
        "id": "22",
        "title": "Stephanie NGUYEN",
        "start": "2025-01-22T20:00:00.000Z",
        "end": "2025-01-22T22:00:00.000Z",
        "allDay": false,
        "className": "bg-soft-danger"
    },
    {
        "id": "23",
        "title": "Bonnie Hicks",
        "start": "2025-01-07T19:00:00.000Z",
        "end": "2025-01-07T21:00:00.000Z",
        "allDay": false,
        "className": "bg-soft-danger"
    },
    {
        "id": "24",
        "title": "Rosa Borjas",
        "start": "2025-01-30T16:00:00.000Z",
        "end": "2025-01-30T18:00:00.000Z",
        "allDay": false,
        "className": "bg-soft-danger"
    }
];

export { category, calendarEvents };
